/* Mirra Masa | Product purchase option gate + existing button tap feedback.
   Shopify may internally pick the first variant. Only a real selection of each
   multi-value color and size can enable the product page Add to Bag button.
   Single-color and single-size options do not require a separate click.
*/
(function () {
  'use strict';
  var mobile = window.matchMedia('(hover: none), (pointer: coarse)');
  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var queued = false;

  function mainButton(form) {
    return form.querySelector('.t4s-product-form__buttons button.t4s-product-form__submit[type="submit"]');
  }

  function selectionsComplete(form) {
    if (form.classList.contains('mm-size-selection-pending')) return false;

    var sizeToggle = form.querySelector('.mm-size-select__toggle');
    if (sizeToggle) {
      var chosen = form.querySelector('.mm-size-select__chosen');
      if (!chosen || !chosen.textContent.trim() ||
          chosen.textContent.trim().toLowerCase() === 'select a size') return false;
    }

    var colors = form.querySelectorAll('.t4s-swatch__option.is-t4s-style__color');
    for (var i = 0; i < colors.length; i++) {
      var items = colors[i].querySelectorAll('[data-swatch-list] > [data-swatch-item].is-sw__color');
      if (items.length > 1) {
        var picked = colors[i].querySelector('[data-swatch-list] > [data-swatch-item].mm-swatch-clicked');
        if (!picked || !picked.classList.contains('is--selected')) return false;
      }
    }
    // The theme must also point to the exact color-size combination the
    // customer selected, not an implicit first/alternate variant.
    var inventory = form.querySelector('.mm-size-select__inventory');
    var variantSelect = form.querySelector('select[name="id"]');
    if (inventory && variantSelect) {
      try {
        var variants = JSON.parse(inventory.textContent);
        var selected = variants.find(function (v) {
          return String(v.id) === String(variantSelect.value);
        });
        if (!selected || !selected.available) return false;
        var sizeRoot = form.querySelector('.mm-size-select');
        if (sizeRoot && form.querySelector('.mm-size-select__toggle')) {
          var sizeIndex = Number(sizeRoot.getAttribute('data-size-position'));
          var chosenText = form.querySelector('.mm-size-select__chosen');
          if (!chosenText || selected.options[sizeIndex] !== chosenText.textContent.trim()) return false;
        }
        for (var c=0; c<colors.length; c++) {
          var all = colors[c].querySelectorAll('[data-swatch-list] > [data-swatch-item].is-sw__color');
          var clicked = all.length===1 ? all[0] :
            colors[c].querySelector('[data-swatch-list] > [data-swatch-item].mm-swatch-clicked.is--selected');
          if (clicked && selected.options[Number(colors[c].getAttribute('data-id'))] !== clicked.getAttribute('data-value')) return false;
        }
      } catch (error) {
        // Fail closed if variant data is present but cannot be validated.
        return false;
      }
    }
    return true;
  }

  function variantAvailable(form, button) {
    if (!button || !button.hasAttribute('data-atc-form')) return false;
    var select = form.querySelector('select[name="id"]');
    if (select && select.selectedIndex >= 0) {
      var selected = select.options[select.selectedIndex];
      if (selected.disabled || selected.classList.contains('is--sold-out')) return false;
    }
    return true;
  }

  function updateForm(form) {
    var button = mainButton(form);
    if (!button) return;
    var chosen = selectionsComplete(form);
    var available = variantAvailable(form, button);
    var wasLocked = button.hasAttribute('data-mm-options-locked');

    if (!chosen) {
      button.setAttribute('data-mm-options-locked', 'true');
      button.classList.add('mm-options-incomplete');
      button.classList.remove('mm-atc-ready');
      if (!button.disabled) button.disabled = true;
      if (button.getAttribute('aria-disabled') !== 'true') button.setAttribute('aria-disabled', 'true');
    } else {
      button.classList.remove('mm-options-incomplete');
      button.removeAttribute('data-mm-options-locked');
      // Release only a button this guard previously locked, only when the
      // theme identifies the selected variant as purchasable.
      if (wasLocked && available && !button.classList.contains('is--loading')) {
        if (button.disabled) button.disabled = false;
        if (button.getAttribute('aria-disabled') === 'true') button.removeAttribute('aria-disabled');
      }
      button.classList.toggle('mm-atc-ready', available && !button.disabled &&
        button.getAttribute('aria-disabled') !== 'true' && !button.classList.contains('is--loading'));
    }

    var wrapper = form.closest('.t4s-product-form__variants');
    var sticky = wrapper && wrapper.querySelector('.mm-mobile-sticky-atc button');
    if (sticky) {
      var allow = chosen && available && !button.disabled &&
        button.getAttribute('aria-disabled') !== 'true';
      sticky.classList.toggle('mm-options-incomplete', !chosen);
      sticky.classList.toggle('mm-atc-ready', allow);
      // Sticky button mirrors the primary form's validated state, even after
      // its built-in scroll-position synchronization runs.
      if (sticky.disabled !== !allow) sticky.disabled = !allow;
      if (!chosen) sticky.setAttribute('aria-disabled', 'true');
      else sticky.removeAttribute('aria-disabled');
    }
  }

  function forms() {
    return document.querySelectorAll('body.template-product form[data-type="add-to-cart-form"]');
  }
  function refresh() {
    queued = false;
    forms().forEach(updateForm);
  }
  function requestRefresh() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(refresh);
  }

  function flash(el) {
    if (!el || !mobile.matches || reducedMotion.matches) return;
    el.classList.remove('mm-button-tap-pulse');
    void el.offsetWidth;
    el.classList.add('mm-button-tap-pulse');
    el.addEventListener('animationend', function finish(event) {
      if (event.animationName !== 'mm-button-tap-flash') return;
      el.classList.remove('mm-button-tap-pulse');
      el.removeEventListener('animationend', finish);
    });
  }

  // Validate immediately before a submission, including Enter-key submission
  // and code paths that do not originate from a button click.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches('body.template-product form[data-type="add-to-cart-form"]')) return;
    if (!selectionsComplete(form) || !variantAvailable(form, mainButton(form))) {
      event.preventDefault();
      event.stopImmediatePropagation();
      updateForm(form);
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    var target = event.target;
    if (!target || !target.closest) return;
    var control = target.closest(
      '.mm-size-guide-link, .mm-mobile-description-fit > summary, ' +
      '.t4s-product-form__buttons button.t4s-product-form__submit, ' +
      '.mm-mobile-sticky-atc button'
    );
    if (control) {
      var isAtc = control.matches('.t4s-product-form__submit, .mm-mobile-sticky-atc button');
      if (isAtc) {
        var wrapper = control.closest('.t4s-product-form__variants');
        var form = control.closest('form[data-type="add-to-cart-form"]') ||
          (wrapper && wrapper.querySelector('form[data-type="add-to-cart-form"]'));
        if (form && (!selectionsComplete(form) || !variantAvailable(form, mainButton(form)))) {
          event.preventDefault();
          event.stopImmediatePropagation();
          updateForm(form);
          return;
        }
      }
      if (!isAtc || (control.classList.contains('mm-atc-ready') &&
          !control.disabled && control.getAttribute('aria-disabled') !== 'true')) flash(control);
    }
    requestRefresh();
  }, true);

  document.addEventListener('change', requestRefresh, true);
  document.addEventListener('variant:changed', requestRefresh, true);
  document.addEventListener('shopify:section:load', function () {
    watchForms();
    requestRefresh();
  });

  var observed = new WeakSet();
  function watchForms() {
    forms().forEach(function (form) {
      if (observed.has(form)) return;
      observed.add(form);
      var observer = new MutationObserver(function (changes) {
        if (changes.some(function (change) {
          // Watch native variant changes, size-choice state, and Shopify button
          // availability. Self-generated changes stabilize after one pass.
          return change.type === 'childList' ||
            change.attributeName === 'class' ||
            change.attributeName === 'disabled' ||
            change.attributeName === 'aria-disabled' ||
            change.attributeName === 'data-atc-form';
        })) requestRefresh();
      });
      observer.observe(form, {
        subtree: true, attributes: true, childList: true,
        attributeFilter: ['class','disabled','aria-disabled','data-atc-form']
      });
    });
  }
  function initialize() {
    if (!document.body || !document.body.classList.contains('template-product')) return;
    watchForms();
    refresh();
    // Shopify may finish initializing its native variant state after DOM ready.
    window.setTimeout(requestRefresh, 120);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
